<template>
  <div>
    <h1 id="jump-to-header">{{heading || "Update"}}</h1>
    <poly-integer-reference-update :id="id"/>
  </div>
</template>

<script>
import PolyIntegerReferenceUpdate from './PolyIntegerReferenceUpdate.vue'

export default {
  components: {
    PolyIntegerReferenceUpdate
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>
